// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Resume styles */

@keyframes pop-on-hover {
  50% {
    transform: scale(1.2);
  }
}

.pop-on-hover {
  display: inline-block;
  vertical-align: middle;
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
}

.pop-on-hover:hover,
.pop-on-hover:focus,
.pop-on-hover:active {
  animation-name: pop-on-hover;
  animation-duration: 0.3s;
  animation-timing-function: linear;
  animation-iteration-count: 1;
}

#resume-button {
  background-color: #db791a;
  color: floralwhite;
}

#resume-button:hover {
  background-color: #e99d51;
  color: floralwhite;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/Resume/Resume.css"],"names":[],"mappings":"AAAA,kBAAkB;;AASlB;EACE;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EAEtB,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;;;EAIE,4BAA4B;EAE5B,wBAAwB;EAExB,iCAAiC;EAEjC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["/* Resume styles */\n\n@-webkit-keyframes pop-on-hover {\n  50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n}\n\n@keyframes pop-on-hover {\n  50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n}\n\n.pop-on-hover {\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-transform: perspective(1px) translateZ(0);\n  transform: perspective(1px) translateZ(0);\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0);\n}\n\n.pop-on-hover:hover,\n.pop-on-hover:focus,\n.pop-on-hover:active {\n  -webkit-animation-name: pop-on-hover;\n  animation-name: pop-on-hover;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n}\n\n#resume-button {\n  background-color: #db791a;\n  color: floralwhite;\n}\n\n#resume-button:hover {\n  background-color: #e99d51;\n  color: floralwhite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
